import { defineStyle, defineStyleConfig, SystemStyleObject } from "@chakra-ui/react";

const solid = defineStyle((props) => {
  const { colorScheme } = props;

  const baseStyles: SystemStyleObject = {
    borderRadius: "18px",

    _loading: {
      opacity: 1,
      cursor: "default",
    },

    _disabled: {
      pointerEvents: "none",
      bg: "gray.300",
      color: "gray.600",
      opacity: 1,
    },
  };

  const spinnerStyles = {
    width: "24px",
    height: "24px",
    borderColor: "white",
  };

  if (colorScheme === "brand") {
    return {
      ...baseStyles,

      _loading: {
        ...(baseStyles._loading as object | undefined ?? {}),
        "bg": "brand.500",
        ".chakra-button__spinner > *": {
          ...spinnerStyles,
          borderBottomColor: "brand.500",
        },
      },
    };
  }

  if (colorScheme === "purple") {
    return {
      ...baseStyles,

      _loading: {
        ...(baseStyles._loading as object | undefined ?? {}),
        "bg": "purple.500",
        ".chakra-button__spinner > *": {
          ...spinnerStyles,
          borderBottomColor: "purple.500",
        },
      },
    };
  }

  if (colorScheme === "red") {
    return {
      ...baseStyles,

      _loading: {
        ...(baseStyles._loading as object | undefined ?? {}),
        "bg": "red.500",
        ".chakra-button__spinner > *": {
          ...spinnerStyles,
          borderBottomColor: "red.500",
        },
      },
    };
  }

  if (colorScheme === "gray") {
    return {
      ...baseStyles,
      bg: "gray.300",
      color: "brand.500",

      _loading: {
        ...(baseStyles._loading as object | undefined ?? {}),
        ".chakra-button__spinner > *": {
          ...spinnerStyles,
          borderColor: "brand.500",
          borderBottomColor: "gray.300",
        },
      },
    };
  }

  return baseStyles;
});

const circle = defineStyle({
  minW: 12,
  w: 12,
  h: 12,
  borderRadius: "full",
  bg: "gray.50",
  p: 0,
});

export const Button = defineStyleConfig({ variants: { solid, circle } });
